import Cookies from 'js-cookie'

const TokenKey = 'XKY-Butcher-DingDing1-Token'
const nameKey = 'XKY-Butcher-DingDing-name'
const userIdKey = 'XKY-Butcher-DingDing-UserId'
const organIdKey = 'XKY-Butcher-DingDing-organId'
const RoleKey = 'XKY-Butcher-DingDing-Role'


export function getToken() {  
  //部署需要去掉路由 next() return  缓存 auth 下面三个 
//   setToken("a599baae7d3cfac1294396e334c986bb866f86ecb7aee6fc6623fea53cd0a194")
//   setName("张媛媛") 
//  setUserId("101502063436296491") 
//   setRole('SALEMANGEHUOYUANMANGEGONGZIMANGECHENGBEN') 
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getName() {
  return Cookies.get(nameKey)
}

export function setName(name) {
  return Cookies.set(nameKey, name)
}

export function removeName() {
  return Cookies.remove(nameKey)
}

export function getUserId() {
  return Cookies.get(userIdKey)
}

export function setUserId(userId) {
  return Cookies.set(userIdKey, userId)
}

export function removeUserId() {
  return Cookies.remove(userIdKey)
}

export function getOrganId() {
  return Cookies.get(organIdKey)
}

export function setOrganId(organId) {
  return Cookies.set(organIdKey, organId)
}

export function removeOrganId() {
  return Cookies.remove(organIdKey)
}

export function getRole() {
  return Cookies.get(RoleKey)
}

export function setRole(role) {
  return Cookies.set(RoleKey, role)
}

export function removeRole() {
  return Cookies.remove(RoleKey)
}